// import {
//     Flex,
//     HStack,
//     Image,
//     Text,
//     VStack,
//     Button,
//     Input,
//     FormControl,
//     Select,
// } from '@chakra-ui/react';
// import { useEffect, useState, useRef } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';
// import { backbtn } from './Icons';
// import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
// import { update_profile } from '../../../redux/actions/profileActions';
// import { useDispatch, useSelector } from 'react-redux';
// import { refreshToken } from '../../../redux/actions/authActions';
// import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';
// import useGetUserDetails from 'hooks/useGetUserDetail';
// import axios from 'axios';
// import { useGetBanks } from 'hooks/useGetBanks';

// const PaymentInfo = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const profileReducer = useSelector((state) => state.profileReducer);

//     let title = location.pathname;
//     var array = title.split('/');

//     const { from } = profileReducer;

//     var decoded = useGetUserDetails();
//     const details = decoded?.flattenedUser?.attributes;

//     const userLogo = details?.partner_imgage;

//     const { banks } = useGetBanks();  

//     const [payment_information, setPaymentInformation] = useState({
//         bank_name: details?.bank_name || '',
//         account_name: details?.account_name || '',
//         account_number: details?.account_number || '',
//         bvn: details?.bvn || '',
//         nin: details?.nin || '',
//         proof_of_address: details?.proof_of_address || '',
//     });

//     const [proofOfAddressFile, setProofOfAddressFile] = useState(null);
//     const [uploadingProof, setUploadingProof] = useState(false);
//     const [isSaving, setIsSaving] = useState(false);
//     const [errors, setErrors] = useState({});

//     const proofFileInput = useRef(null);

//     useEffect(() => {
//         if (from === 'payment') {
//             navigate('/dashboard');
//             dispatch(refreshToken());
//         }
//     }, [from, navigate, dispatch]);

//     const handleProofUploadClick = () => {
//         proofFileInput.current.click();
//     };

//     const handleProofUpload = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         // Validate file type (PDF, JPG, PNG)
//         const validTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
//         if (!validTypes.includes(file.type)) {
//             setErrors({ ...errors, proof_of_address: 'Please upload a PDF, JPG, or PNG file' });
//             return;
//         }

//         // Validate file size (max 5MB)
//         if (file.size > 5 * 1024 * 1024) {
//             setErrors({ ...errors, proof_of_address: 'File size must be less than 5MB' });
//             return;
//         }

//         setUploadingProof(true);
//         setProofOfAddressFile(file);

//         try {
//             const formData = new FormData();
//             formData.append('file', file);
//             formData.append('upload_preset', 'o5dxfulx');

//             const response = await axios.post(
//                 'https://api.cloudinary.com/v1_1/tajiri/image/upload',
//                 formData,
//             );

//             setPaymentInformation({
//                 ...payment_information,
//                 proof_of_address: response?.data?.url,
//             });
//             setErrors({ ...errors, proof_of_address: '' });
//         } catch (error) {
//             setErrors({ ...errors, proof_of_address: 'Failed to upload file. Please try again.' });
//         } finally {
//             setUploadingProof(false);
//         }
//     };

//     const validateForm = () => {
//         const newErrors = {};

//         if (payment_information.bvn && payment_information.bvn.length !== 11) {
//             newErrors.bvn = 'BVN must be exactly 11 digits';
//         }

//         if (payment_information.nin && payment_information.nin.length !== 11) {
//             newErrors.nin = 'NIN must be exactly 11 digits';
//         }

//         if (!payment_information.bank_name || payment_information.bank_name.trim() === '') {
//             newErrors.bank_name = 'Bank name is required';
//         }

//         if (!payment_information.account_name || payment_information.account_name.trim() === '') {
//             newErrors.account_name = 'Account name is required';
//         }

//         if (
//             !payment_information.account_number ||
//             payment_information.account_number.length !== 10
//         ) {
//             newErrors.account_number = 'Account number must be exactly 10 digits';
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleProceed = () => {
//         if (!validateForm()) {
//             return;
//         }

//         setIsSaving(true);

//         const data = {
//             payment_information: { ...payment_information },
//         };
//         let fro = 'payment';
//         dispatch(update_profile(data, fro));

//         setTimeout(() => {
//             setIsSaving(false);
//         }, 2000);
//     };

//     return (
//         <ProfileConatiner>
//             <HStack justify="start" alignItems="center" display={'flex'}>
//                 <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
//                 <div className="menuSection">
//                     <Text fontSize="18px">
//                         {array[array.length - 1] === 'paymentinfo' && 'Payment Information'}
//                     </Text>
//                 </div>
//                 <div></div>
//             </HStack>

//             <Flex w="full" h="full" justify="center" alignItems="center" flexDir="column">
//                 <VStack mt="30px">
//                     <Text textAlign="center" fontSize="14px" mb="10px">
//                         Your Agent ID <br />
//                         <b>{details?.agent_id || 'TAJ-4626'}</b>
//                     </Text>
//                     <Image
//                         src={userLogo || ImagePlaceholder}
//                         w="64px"
//                         h="64px"
//                         borderRadius="50%"
//                     />
//                 </VStack>

//                 <VStack
//                     mt="40px"
//                     w="full"
//                     justifyContent="space-between"
//                     alignItems="self-start"
//                     spacing={0}>
//                     <Text
//                         w="full"
//                         pt={{ base: '20px', lg: '15px' }}
//                         pb="12px"
//                         pl="5px"
//                         bg="#F7F9FA"
//                         color="#6C7072"
//                         fontSize="12px"
//                         fontWeight="600">
//                         BANK DETAILS
//                     </Text>

//                     <FormControl isInvalid={errors.bank_name}>
//                         <Flex
//                             w="full"
//                             justifyContent="space-between"
//                             pl="5px"
//                             py={{ base: '20px', lg: '10px' }}
//                             borderTop="1px solid #f2f4f5">
//                             <Text fontSize="16px" color="#090A0A">
//                                 Bank Name
//                             </Text>
//                             <VStack w="45%" align="flex-end" spacing={1}>
//                                 <Select
//                                     w="100%"
//                                     textAlign="right"
//                                     placeholder="Select bank name"
//                                     variant="unstyled"
//                                     value={payment_information.bank_name}
//                                     onChange={(e) => {
//                                         setPaymentInformation({
//                                             ...payment_information,
//                                             bank_name: e.target.value,
//                                         });
//                                         setErrors({ ...errors, bank_name: '' });
//                                     }}>
//                                     {banks.map((bank) => (
//                                         <option key={bank.bankcode} value={bank.bankname}>
//                                             {bank.bankname}
//                                         </option>
//                                     ))}
//                                 </Select>
//                                 {errors.bank_name && (
//                                     <Text fontSize="xs" color="red.500">
//                                         {errors.bank_name}
//                                     </Text>
//                                 )}
//                             </VStack>
//                         </Flex>
//                     </FormControl>

//                     <FormControl isInvalid={errors.account_name}>
//                         <Flex
//                             w="full"
//                             justifyContent="space-between"
//                             pl="5px"
//                             py={{ base: '20px', lg: '10px' }}
//                             borderTop="1px solid #f2f4f5">
//                             <Text fontSize="16px" color="#090A0A">
//                                 Account Name
//                             </Text>
//                             <VStack w="45%" align="flex-end" spacing={1}>
//                                 <Input
//                                     w="100%"
//                                     textAlign="right"
//                                     type="text"
//                                     placeholder="enter account name"
//                                     variant="unstyled"
//                                     value={payment_information.account_name}
//                                     onInput={(e) => {
//                                         setPaymentInformation({
//                                             ...payment_information,
//                                             account_name: e.target.value,
//                                         });
//                                         setErrors({ ...errors, account_name: '' });
//                                     }}
//                                 />
//                                 {errors.account_name && (
//                                     <Text fontSize="xs" color="red.500">
//                                         {errors.account_name}
//                                     </Text>
//                                 )}
//                             </VStack>
//                         </Flex>
//                     </FormControl>

//                     <FormControl isInvalid={errors.account_number}>
//                         <Flex
//                             w="full"
//                             justifyContent="space-between"
//                             pl="5px"
//                             py={{ base: '20px', lg: '10px' }}
//                             borderTop="1px solid #f2f4f5">
//                             <Text fontSize="16px" color="#090A0A">
//                                 Account No.
//                             </Text>
//                             <VStack w="45%" align="flex-end" spacing={1}>
//                                 <Input
//                                     w="100%"
//                                     textAlign="right"
//                                     type="text"
//                                     inputMode="numeric"
//                                     placeholder="enter account no"
//                                     variant="unstyled"
//                                     maxLength={10}
//                                     value={payment_information.account_number}
//                                     onInput={(e) => {
//                                         const value = e.target.value.replace(/\D/g, '');
//                                         setPaymentInformation({
//                                             ...payment_information,
//                                             account_number: value,
//                                         });
//                                         setErrors({ ...errors, account_number: '' });
//                                     }}
//                                 />
//                                 {errors.account_number && (
//                                     <Text fontSize="xs" color="red.500">
//                                         {errors.account_number}
//                                     </Text>
//                                 )}
//                             </VStack>
//                         </Flex>
//                     </FormControl>

//                     <Text
//                         w="full"
//                         pt={{ base: '20px', lg: '15px' }}
//                         pb="12px"
//                         pl="5px"
//                         bg="#F7F9FA"
//                         color="#6C7072"
//                         fontSize="12px"
//                         fontWeight="600">
//                         IDENTITY VERIFICATION
//                     </Text>

//                     <FormControl isInvalid={errors.bvn}>
//                         <Flex
//                             w="full"
//                             justifyContent="space-between"
//                             pl="5px"
//                             py={{ base: '20px', lg: '10px' }}
//                             borderTop="1px solid #f2f4f5">
//                             <Text fontSize="16px" color="#090A0A">
//                                 BVN
//                             </Text>
//                             <VStack w="45%" align="flex-end" spacing={1}>
//                                 <Input
//                                     w="100%"
//                                     textAlign="right"
//                                     type="text"
//                                     inputMode="numeric"
//                                     placeholder="enter BVN"
//                                     variant="unstyled"
//                                     maxLength={11}
//                                     value={payment_information.bvn}
//                                     onInput={(e) => {
//                                         const value = e.target.value.replace(/\D/g, '');
//                                         setPaymentInformation({
//                                             ...payment_information,
//                                             bvn: value,
//                                         });
//                                         setErrors({ ...errors, bvn: '' });
//                                     }}
//                                 />
//                                 {errors.bvn && (
//                                     <Text fontSize="xs" color="red.500">
//                                         {errors.bvn}
//                                     </Text>
//                                 )}
//                             </VStack>
//                         </Flex>
//                     </FormControl>

//                     <FormControl isInvalid={errors.nin}>
//                         <Flex
//                             w="full"
//                             justifyContent="space-between"
//                             pl="5px"
//                             py={{ base: '20px', lg: '10px' }}
//                             borderTop="1px solid #f2f4f5">
//                             <Text fontSize="16px" color="#090A0A">
//                                 NIN
//                             </Text>
//                             <VStack w="45%" align="flex-end" spacing={1}>
//                                 <Input
//                                     w="100%"
//                                     textAlign="right"
//                                     type="text"
//                                     inputMode="numeric"
//                                     placeholder="enter NIN"
//                                     variant="unstyled"
//                                     maxLength={11}
//                                     value={payment_information.nin}
//                                     onInput={(e) => {
//                                         const value = e.target.value.replace(/\D/g, '');
//                                         setPaymentInformation({
//                                             ...payment_information,
//                                             nin: value,
//                                         });
//                                         setErrors({ ...errors, nin: '' });
//                                     }}
//                                 />
//                                 {errors.nin && (
//                                     <Text fontSize="xs" color="red.500">
//                                         {errors.nin}
//                                     </Text>
//                                 )}
//                             </VStack>
//                         </Flex>
//                     </FormControl>

//                     <FormControl isInvalid={errors.proof_of_address}>
//                         <Flex
//                             w="full"
//                             justifyContent="space-between"
//                             pl="5px"
//                             py={{ base: '20px', lg: '10px' }}
//                             borderTop="1px solid #f2f4f5"
//                             alignItems="center">
//                             <VStack align="flex-start" spacing={0}>
//                                 <Text fontSize="16px" color="#090A0A">
//                                     Proof of Address
//                                 </Text>
//                                 <Text fontSize="12px" color="#6C7072">
//                                     Utility bill, bank statement (Optional)
//                                 </Text>
//                             </VStack>
//                             <VStack align="flex-end" spacing={1}>
//                                 <Button
//                                     bg="#E7E7FF"
//                                     borderRadius="48px"
//                                     py="8px"
//                                     px="16px"
//                                     h="32px"
//                                     color="#1b3b5f"
//                                     onClick={handleProofUploadClick}
//                                     fontWeight="500"
//                                     fontSize="13px"
//                                     isLoading={uploadingProof}
//                                     _hover={{ bg: '#d0d0ff' }}>
//                                     {payment_information.proof_of_address
//                                         ? 'Change File'
//                                         : 'Upload File'}
//                                 </Button>
//                                 {proofOfAddressFile && (
//                                     <Text fontSize="xs" color="green.500">
//                                         {proofOfAddressFile.name}
//                                     </Text>
//                                 )}
//                                 {errors.proof_of_address && (
//                                     <Text fontSize="xs" color="red.500">
//                                         {errors.proof_of_address}
//                                     </Text>
//                                 )}
//                             </VStack>
//                         </Flex>
//                         <Input
//                             type="file"
//                             ref={proofFileInput}
//                             onChange={handleProofUpload}
//                             accept=".pdf,.jpg,.jpeg,.png"
//                             style={{ display: 'none' }}
//                         />
//                     </FormControl>

//                     <Flex mt="24px" w="full" justify="center">
//                         <Button
//                             colorScheme="grey"
//                             bg="#1b3b5f"
//                             color="white"
//                             fontWeight="400"
//                             borderRadius="48px"
//                             fontSize="14px"
//                             px="40px"
//                             onClick={handleProceed}
//                             isLoading={isSaving}
//                             loadingText="Saving..."
//                             isDisabled={isSaving}
//                             _hover={{ bg: '#152d47' }}
//                             _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}>
//                             Save Changes
//                         </Button>
//                     </Flex>
//                 </VStack>
//             </Flex>
//         </ProfileConatiner>
//     );
// };

// export default PaymentInfo;


/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useMemo, useCallback, memo } from 'react';
import {
    Box, Flex, HStack, VStack, Text, Heading, Image, Button, Input,
    InputGroup, InputLeftElement, FormControl, FormLabel, Icon, Spinner,
} from '@chakra-ui/react';
import { Formik, useFormikContext } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineUpload, AiOutlineFileText, AiOutlineCheckCircle } from 'react-icons/ai';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import axios from 'axios';

import CustomSelect from 'components/CustomSelect';
import { update_profile } from '../../../redux/actions/profileActions';
import { refreshToken } from '../../../redux/actions/authActions';
import useGetUserDetails from 'hooks/useGetUserDetail';
import { useGetBanks } from 'hooks/useGetBanks';
import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */
const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const BORDER_INPUT= '#DCE3EE';
const DANGER      = '#E53E3E';
const SUCCESS     = '#10B981';
const SUCCESS_BG  = '#ECFDF5';

const FONT      = "'Bricolage Grotesque', sans-serif";
const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */
const BackArrowIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M19 12H5M12 19l-7-7 7-7"
            stroke="currentColor" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   VALIDATION SCHEMA
   ───────────────────────────────────────────────────────────── */

const paymentSchema = Yup.object().shape({
    bank_name: Yup.string()
        .trim()
        .required('Bank name is required'),
    account_name: Yup.string()
        .trim()
        .min(2, 'Account name must be at least 2 characters')
        .required('Account name is required'),
    account_number: Yup.string()
        .matches(/^\d+$/, 'Account number must contain only digits')
        .length(10, 'Account number must be exactly 10 digits')
        .required('Account number is required'),
    bvn: Yup.string()
        .matches(/^\d*$/, 'BVN must contain only digits')
        .test('bvn-length', 'BVN must be exactly 11 digits', (val) =>
            !val || val.length === 11
        )
        .nullable(),
    nin: Yup.string()
        .matches(/^\d*$/, 'NIN must contain only digits')
        .test('nin-length', 'NIN must be exactly 11 digits', (val) =>
            !val || val.length === 11
        )
        .nullable(),
    proof_of_address: Yup.string().optional(),
});

/* ─────────────────────────────────────────────────────────────
   DIRTY FORM GUARD — browser-level only
   ───────────────────────────────────────────────────────────── */

const DirtyFormGuard = ({ when }) => {
    useEffect(() => {
        if (!when) return undefined;
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [when]);
    return null;
};

/* ─────────────────────────────────────────────────────────────
   REUSABLE FORM PIECES
   ───────────────────────────────────────────────────────────── */

const FieldError = memo(function FieldError({ message }) {
    if (!message) return null;
    return (
        <Text
            mt="4px"
            fontSize="11px"
            color={DANGER}
            fontWeight="500"
            fontFamily={FONT}
            role="alert"
        >
            {message}
        </Text>
    );
});

const SectionHeader = memo(function SectionHeader({ children, isFirst }) {
    return (
        <Box w="full" mt={isFirst ? '0' : '24px'} mb="6px">
            <Text
                color={MUTED}
                fontSize="11px"
                fontWeight="800"
                fontFamily={FONT}
                letterSpacing="0.06em"
                textTransform="uppercase"
            >
                {children}
            </Text>
            <Box mt="6px" h="1px" bg={BORDER} />
        </Box>
    );
});

const FieldRow = memo(function FieldRow({ label, helper, error, children }) {
    return (
        <FormControl py="10px">
            <Flex
                direction={{ base: 'column', md: 'row' }}
                gap={{ base: '6px', md: '24px' }}
                align={{ base: 'stretch', md: 'flex-start' }}
            >
                <Box minW={{ md: '180px' }} maxW={{ md: '180px' }} pt={{ md: '8px' }}>
                    <FormLabel
                        mb="0"
                        fontSize="13px"
                        color={INK}
                        fontWeight="600"
                        fontFamily={FONT}
                        lineHeight="1.3"
                    >
                        {label}
                    </FormLabel>
                    {helper && (
                        <Text
                            mt="2px"
                            fontSize="11px"
                            color={FAINT}
                            fontFamily={FONT}
                            lineHeight="1.4"
                        >
                            {helper}
                        </Text>
                    )}
                </Box>
                <Box flex="1" minW="0">
                    {children}
                    <FieldError message={error} />
                </Box>
            </Flex>
        </FormControl>
    );
});

const RealInput = memo(function RealInput({ ...props }) {
    return (
        <Input
            fontSize="13.5px"
            fontFamily={FONT}
            color={INK}
            h="38px"
            bg={SURFACE}
            border="1px solid"
            borderColor={BORDER_INPUT}
            borderRadius="8px"
            px="12px"
            _placeholder={{ color: FAINT, fontSize: '13px' }}
            _hover={{ borderColor: '#C5D0DF' }}
            _focusVisible={{
                borderColor: NAVY,
                boxShadow: `0 0 0 3px ${CYAN}77`,
                outline: 'none',
            }}
            transition="border-color 0.15s ease, box-shadow 0.15s ease"
            {...props}
        />
    );
});

/* ─────────────────────────────────────────────────────────────
   AGENT IDENTITY STRIP — top compact card
   ───────────────────────────────────────────────────────────── */

const AgentIdentityStrip = ({ imageUrl, agentId }) => (
    <Flex
        align="center"
        gap="16px"
        p="14px"
        bg={SURFACE}
        border="1px solid"
        borderColor={BORDER}
        borderRadius="10px"
        mb="20px"
    >
        <Image
            src={imageUrl || ImagePlaceholder}
            w="56px"
            h="56px"
            borderRadius="50%"
            objectFit="cover"
            border="2px solid"
            borderColor={SURFACE_ALT}
            flexShrink={0}
        />
        <Box flex="1" minW="0">
            <Text
                fontSize="10.5px"
                color={FAINT}
                fontWeight="700"
                letterSpacing="0.06em"
                textTransform="uppercase"
                mb="2px"
            >
                Agent ID
            </Text>
            <Text
                fontSize="14px"
                color={INK}
                fontWeight="800"
                fontFamily={FONT}
                noOfLines={1}
            >
                {agentId || '—'}
            </Text>
        </Box>
    </Flex>
);

/* ─────────────────────────────────────────────────────────────
   PROOF OF ADDRESS UPLOAD
   ───────────────────────────────────────────────────────────── */

const ProofOfAddressUpload = ({ currentUrl, fileName, onUpload }) => {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handleClick = () => inputRef.current?.click();

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        /* Reset value so re-selecting the same file fires onChange */
        event.target.value = '';

        const validTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            toast.error('Please upload a PDF, JPG, or PNG file');
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            toast.error('File size must be less than 5MB');
            return;
        }

        setUploading(true);
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('upload_preset', 'o5dxfulx');

            const response = await axios.post(
                'https://api.cloudinary.com/v1_1/tajiri/image/upload',
                formData,
            );
            const url = response?.data?.secure_url || response?.data?.url;
            if (!url) throw new Error('Upload returned no URL');
            onUpload({ url, name: file.name });
            toast.success('File uploaded');
        } catch (error) {
            console.error('Proof upload failed:', error);
            toast.error('Failed to upload file. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    const hasFile = !!currentUrl;
    const displayName = fileName || (currentUrl ? 'Uploaded document' : null);

    return (
        <Box>
            <Flex align="center" gap="10px" flexWrap="wrap">
                <Button
                    onClick={handleClick}
                    isLoading={uploading}
                    bg={hasFile ? SUCCESS_BG : SURFACE_ALT}
                    color={hasFile ? SUCCESS : NAVY}
                    fontWeight="700"
                    fontSize="12px"
                    fontFamily={FONT}
                    h="38px"
                    px="14px"
                    borderRadius="8px"
                    border="1px solid"
                    borderColor={hasFile ? SUCCESS : BORDER_INPUT}
                    leftIcon={
                        hasFile
                            ? <Icon as={AiOutlineCheckCircle} fontSize="15px" />
                            : <Icon as={AiOutlineUpload} fontSize="14px" />
                    }
                    _hover={{
                        bg: hasFile ? '#D6F5E5' : CYAN,
                        borderColor: hasFile ? SUCCESS : NAVY,
                    }}
                >
                    {hasFile ? 'Replace file' : 'Upload file'}
                </Button>

                {displayName && (
                    <Flex
                        align="center"
                        gap="6px"
                        bg={SURFACE_ALT}
                        border="1px solid"
                        borderColor={BORDER}
                        borderRadius="8px"
                        h="38px"
                        px="10px"
                        maxW="240px"
                        minW="0"
                    >
                        <Icon as={AiOutlineFileText} color={MUTED} fontSize="14px" flexShrink={0} />
                        <Text
                            fontSize="12px"
                            color={INK}
                            fontFamily={FONT}
                            noOfLines={1}
                        >
                            {displayName}
                        </Text>
                    </Flex>
                )}
            </Flex>

            <Input
                ref={inputRef}
                type="file"
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png"
                display="none"
            />
        </Box>
    );
};

/* ─────────────────────────────────────────────────────────────
   FORM BODY
   ───────────────────────────────────────────────────────────── */

const PaymentFormBody = ({
    isSubmitting, banks, banksLoading,
    profileImage, agentId,
    uploadedFileName, setUploadedFileName,
}) => {
    const {
        values, errors, touched,
        handleChange, handleBlur, setFieldValue, setFieldTouched,
        dirty, handleSubmit,
    } = useFormikContext();

    const bankOptions = useMemo(
        () => (banks || []).map((b) => ({
            label: b.bankname,
            value: b.bankcode,
            bankname: b.bankname,
        })),
        [banks]
    );

    const handleBankChange = (e) => {
        try {
            const parsed = JSON.parse(e.target.value);
            /* Store BOTH name (for display) and code (for backend) */
            setFieldValue('bank_name', parsed.bankname || parsed.label);
            setFieldValue('bank_code', parsed.value);
            setFieldTouched('bank_name', true);
        } catch {
            setFieldValue('bank_name', e.target.value);
            setFieldTouched('bank_name', true);
        }
    };

    /* Restrict numeric input to digits + maxLength */
    const numericOnChange = (fieldName, maxLength) => (e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, maxLength);
        setFieldValue(fieldName, digits);
    };

    /* Build current bank select value */
    const bankSelectValue = useMemo(() => {
        if (!values.bank_name) return '';
        const match = bankOptions.find((b) => b.bankname === values.bank_name);
        if (!match) return '';
        return JSON.stringify(match);
    }, [bankOptions, values.bank_name]);

    return (
        <form onSubmit={handleSubmit}>
            <DirtyFormGuard when={dirty && !isSubmitting} />

            <AgentIdentityStrip imageUrl={profileImage} agentId={agentId} />

            <Box
                bg={SURFACE}
                border="1px solid"
                borderColor={BORDER}
                borderRadius="10px"
                p={{ base: '16px', md: '20px 24px' }}
            >

                {/* BANK DETAILS */}
                <SectionHeader isFirst>Bank details</SectionHeader>

                <FieldRow
                    label="Bank name"
                    error={touched.bank_name && errors.bank_name}
                >
                    {banksLoading && bankOptions.length === 0 ? (
                        <Flex
                            align="center"
                            gap="8px"
                            h="38px"
                            px="12px"
                            bg={SURFACE_ALT}
                            border="1px solid"
                            borderColor={BORDER}
                            borderRadius="8px"
                        >
                            <Spinner size="xs" color={MUTED} />
                            <Text fontSize="13px" color={MUTED}>Loading banks…</Text>
                        </Flex>
                    ) : (
                        <CustomSelect
                            name="bank_name"
                            placeholder="Select bank name"
                            options={bankOptions}
                            value={bankSelectValue}
                            onChange={handleBankChange}
                            disabled={bankOptions.length === 0}
                            size="md"
                            h="38px"
                            fontSize="13.5px"
                            bg={SURFACE}
                            borderColor={BORDER_INPUT}
                            borderRadius="8px"
                            _hover={{ borderColor: '#C5D0DF' }}
                            _focus={{ borderColor: NAVY, boxShadow: `0 0 0 3px ${CYAN}77` }}
                        />
                    )}
                </FieldRow>

                <FieldRow
                    label="Account name"
                    error={touched.account_name && errors.account_name}
                >
                    <RealInput
                        name="account_name"
                        placeholder="Enter account name"
                        value={values.account_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </FieldRow>

                <FieldRow
                    label="Account number"
                    helper="10-digit Nigerian bank account number"
                    error={touched.account_number && errors.account_number}
                >
                    <RealInput
                        name="account_number"
                        type="text"
                        inputMode="numeric"
                        placeholder="0123456789"
                        maxLength={10}
                        value={values.account_number}
                        onChange={numericOnChange('account_number', 10)}
                        onBlur={handleBlur}
                        maxW={{ md: '240px' }}
                    />
                </FieldRow>

                {/* IDENTITY VERIFICATION */}
                <SectionHeader>Identity verification</SectionHeader>

                <FieldRow
                    label="BVN"
                    helper="Bank Verification Number — 11 digits (optional)"
                    error={touched.bvn && errors.bvn}
                >
                    <RealInput
                        name="bvn"
                        type="text"
                        inputMode="numeric"
                        placeholder="12345678901"
                        maxLength={11}
                        value={values.bvn}
                        onChange={numericOnChange('bvn', 11)}
                        onBlur={handleBlur}
                        maxW={{ md: '240px' }}
                    />
                </FieldRow>

                <FieldRow
                    label="NIN"
                    helper="National Identification Number — 11 digits (optional)"
                    error={touched.nin && errors.nin}
                >
                    <RealInput
                        name="nin"
                        type="text"
                        inputMode="numeric"
                        placeholder="12345678901"
                        maxLength={11}
                        value={values.nin}
                        onChange={numericOnChange('nin', 11)}
                        onBlur={handleBlur}
                        maxW={{ md: '240px' }}
                    />
                </FieldRow>

                <FieldRow
                    label="Proof of address"
                    helper="Utility bill or bank statement (PDF, JPG, PNG · max 5MB)"
                    error={touched.proof_of_address && errors.proof_of_address}
                >
                    <ProofOfAddressUpload
                        currentUrl={values.proof_of_address}
                        fileName={uploadedFileName}
                        onUpload={({ url, name }) => {
                            setFieldValue('proof_of_address', url);
                            setUploadedFileName(name);
                        }}
                    />
                </FieldRow>
            </Box>

            {/* SAVE BUTTON */}
            <Flex
                mt="20px"
                justify="flex-end"
                w="full"
                pt="12px"
                borderTop="1px solid"
                borderColor={BORDER}
            >
                <Button
                    type="submit"
                    bg={NAVY}
                    color="white"
                    _hover={{ bg: NAVY_DEEP }}
                    _active={{ bg: NAVY_DEEP }}
                    _disabled={{
                        bg: BORDER,
                        color: FAINT,
                        cursor: 'not-allowed',
                    }}
                    w={{ base: 'full', md: 'auto' }}
                    minW={{ md: '160px' }}
                    h="40px"
                    borderRadius="8px"
                    fontWeight="700"
                    fontSize="13px"
                    fontFamily={FONT}
                    isLoading={isSubmitting}
                    loadingText="Saving…"
                    isDisabled={isSubmitting || !dirty}
                >
                    Save changes
                </Button>
            </Flex>
        </form>
    );
};

/* ─────────────────────────────────────────────────────────────
   MAIN — PAYMENT INFO PAGE
   ───────────────────────────────────────────────────────────── */

const PaymentInfo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const profileReducer = useSelector((state) => state.profileReducer);
    const { from } = profileReducer;

    const { flattenedUser } = useGetUserDetails() || {};
    const details = flattenedUser?.attributes;

    const { banks, isLoading: banksLoading } = useGetBanks();

    const pageTitle = location.pathname.split('/').pop() === 'paymentinfo'
        ? 'Payment information'
        : 'Payment information';

    /* Redirect-after-save guard — prevents stale 'from' triggering on mount */
    const [hasSavedThisSession, setHasSavedThisSession] = useState(false);
    useEffect(() => {
        if (from === 'payment' && hasSavedThisSession) {
            dispatch(refreshToken());
            navigate('/dashboard');
        }
    }, [from, hasSavedThisSession, navigate, dispatch]);

    /* Track local filename for uploaded proof — Cloudinary URL alone
       doesn't preserve original filename, so we keep it in memory */
    const [uploadedFileName, setUploadedFileName] = useState(null);

    const initialValues = useMemo(() => ({
        bank_name:        details?.bank_name        || '',
        bank_code:        details?.bank_code        || '',
        account_name:     details?.account_name     || '',
        account_number:   details?.account_number   || '',
        bvn:              details?.bvn              || '',
        nin:              details?.nin              || '',
        proof_of_address: details?.proof_of_address || '',
    }), [details]);

    const handleSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
        const payload = {
            payment_information: {
                bank_name:        values.bank_name,
                bank_code:        values.bank_code,
                account_name:     values.account_name,
                account_number:   values.account_number,
                bvn:              values.bvn || '',
                nin:              values.nin || '',
                proof_of_address: values.proof_of_address || '',
            },
        };

        try {
            await dispatch(update_profile(payload, 'payment'));
            setHasSavedThisSession(true);
            resetForm({ values });
        } catch (error) {
            console.error('Save failed:', error);
        } finally {
            setSubmitting(false);
        }
    }, [dispatch]);

    return (
        <ProfileConatiner>
            <Box
                maxW="780px"
                mx="auto"
                w="full"
                px={{ base: '12px', md: '20px' }}
                py={{ base: '8px', md: '12px' }}
                fontFamily={FONT}
            >
                {/* HEADER */}
                <HStack spacing="8px" align="center" mb="14px">
                    <Button
                        onClick={() => navigate(-1)}
                        variant="ghost"
                        size="sm"
                        h="32px"
                        w="32px"
                        minW="32px"
                        p="0"
                        borderRadius="7px"
                        color={MUTED}
                        _hover={{ bg: SURFACE_ALT, color: NAVY }}
                        _focusVisible={{
                            outline: `2px solid ${NAVY}`,
                            outlineOffset: '2px',
                        }}
                        aria-label="Go back"
                    >
                        <BackArrowIcon />
                    </Button>
                    <Heading
                        as="h1"
                        fontSize={{ base: '17px', md: '19px' }}
                        fontWeight="800"
                        color={INK}
                        fontFamily={FONT}
                        letterSpacing="-0.02em"
                    >
                        {pageTitle}
                    </Heading>
                </HStack>

                {/* FORM */}
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={paymentSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <PaymentFormBody
                            isSubmitting={isSubmitting}
                            banks={banks}
                            banksLoading={banksLoading}
                            profileImage={details?.partner_imgage}
                            agentId={details?.agent_id}
                            uploadedFileName={uploadedFileName}
                            setUploadedFileName={setUploadedFileName}
                        />
                    )}
                </Formik>
            </Box>
        </ProfileConatiner>
    );
};

export default PaymentInfo;